import { Outlet } from "@tanstack/react-router"

export const Scanners = () => {
  return <Outlet />
}
